// Copyright 2026. WebPros International GmbH. All rights reserved.

import {
    List,
    Text,
    Translate,
} from '@plesk/ui-library';
import { Dialog } from 'common/components/Dialog/Dialog';
import { useMemo } from 'react';
import { IComputeResourceRecoveryReadinessStatusResponse } from 'common/api/resources/DisasterRecovery';

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    ipBlocks: IComputeResourceRecoveryReadinessStatusResponse['destination_compute_resources'][number]['compatibility_details']['missed_ip_blocks'];
}

export default function IpBlocksConflictDialog({
    isOpen,
    onClose,
    ipBlocks,
}: IProps) {

    const columns = useMemo(() => [
        {
            key: 'id',
            title: 'ID',
        },
        {
            key: 'name',
            title: <Translate content={'disasterRecovery.readinessStatus.destinationComputeResources.dialogs.ipBlocks.table.name'} />,
        },
    ], []);

    return (
        <Dialog
            isOpen={isOpen}
            heading={<Translate content="disasterRecovery.readinessStatus.destinationComputeResources.table.ipBlocks" />}
            size={'sm'}
            closeHandler={onClose}
        >
            <Text component={'p'}>
                <Translate content={'disasterRecovery.readinessStatus.destinationComputeResources.dialogs.ipBlocks.caption'} />
            </Text>

            <List
                columns={columns}
                data={ipBlocks}
                rowKey={'id'}
            />
        </Dialog>
    );
}
